// Biblioteca de recursos del programa: los publica el admin, todos los consultan.
import apiService from './api';

export type ResourceType = 'document' | 'video' | 'link' | 'image' | 'other';

export interface ResourceTag {
  id: number;
  name: string;
  color?: string | null;
  sort_order?: number;
  resources_count?: number;
}

export interface Resource {
  id: number;
  title: string;
  description?: string | null;
  type: ResourceType;
  file_path?: string | null;
  file_name?: string | null;
  file_size?: number | null;
  url?: string | null;
  uploaded_by: number;
  uploader_first_name?: string | null;
  uploader_last_name?: string | null;
  is_public: number | boolean;
  downloads: number;
  created_at: string;
  tags: ResourceTag[];
}

const resourcesApi = {
  list: async (): Promise<Resource[]> =>
    (await apiService.get('/resources')).data?.data || [],

  tags: async (): Promise<ResourceTag[]> =>
    (await apiService.get('/resources/tags')).data?.data || [],

  // Enlace o video de YouTube.
  createLink: async (payload: {
    title: string; description?: string; type: ResourceType; url: string; tag_ids: number[];
  }) => (await apiService.post('/resources', payload)).data,

  // Archivo (PDF, imagen, mp4…).
  upload: async (form: FormData, onProgress?: (pct: number) => void) =>
    (await apiService.post('/resources/upload', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: (ev: any) =>
        onProgress?.(Math.round((ev.loaded * 100) / (ev.total || 100))),
    })).data,

  update: async (id: number, payload: Record<string, any>) =>
    (await apiService.put(`/resources/${id}`, payload)).data,

  remove: async (id: number) => (await apiService.delete(`/resources/${id}`)).data,

  download: async (id: number) =>
    apiService.get(`/resources/${id}/download`, { responseType: 'blob' }),

  createTag: async (name: string) =>
    (await apiService.post('/resources/tags', { name })).data,

  renameTag: async (id: number, name: string) =>
    (await apiService.put(`/resources/tags/${id}`, { name })).data,

  deleteTag: async (id: number) =>
    (await apiService.delete(`/resources/tags/${id}`)).data,
};

// Archivos de Google Drive: se pueden previsualizar embebidos.
export const driveId = (url?: string | null): string | null => {
  if (!url) return null;
  const m = url.match(/drive\.google\.com\/file\/d\/([\w-]+)/) || url.match(/drive\.google\.com\/open\?id=([\w-]+)/);
  return m ? m[1] : null;
};

// Reproductor embebido de YouTube a partir de la URL que pegó el admin.
export const youtubeId = (url?: string | null): string | null => {
  if (!url) return null;
  const m = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/);
  return m ? m[1] : null;
};

export default resourcesApi;
